import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateAccrualPolicyRequestSchema,
  TCreateAccrualPolicyResponseSchema,
} from "./createAccrualPolicy.schema";

export const createAccrualPolicy = (axios: IAxiosInstance) => {
  return async (requestData: TCreateAccrualPolicyRequestSchema) => {
    const { data } = await axios.noRetry.post<
      IApiResponse<TCreateAccrualPolicyResponseSchema> & {
        errors?: ReadonlyArray<{ readonly message?: string }>;
      }
    >("/accrual-policies", requestData);

    if (data.success) {
      return data.data;
    }

    const message = data.errors?.[0]?.message;
    throw new Error(message ?? "Something went wrong");
  };
};
